import { render, staticRenderFns } from "./EventSharingAsset.vue?vue&type=template&id=0dd16769&scoped=true"
import script from "./EventSharingAsset.vue?vue&type=script&lang=ts"
export * from "./EventSharingAsset.vue?vue&type=script&lang=ts"
import style0 from "./EventSharingAsset.vue?vue&type=style&index=0&id=0dd16769&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd16769",
  null
  
)

export default component.exports